import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalModule } from 'ngx-bootstrap';
import { AddEditCandidateContactModule } from 'src/app/shared/add-edit-candidate-contact/add-edit-candidate-contact.module';
import {
  AddEditEmployeeModule
} from 'src/app/pages/mission-control-page/employee-management-page/add-edit-employee/add-edit-employee.module';
import { AddEditDocumentFolderModule } from '../add-edit-document-folder/add-edit-document-folder.module';
import { UploadCandidateDocumentModule } from '../upload-candidate-document/upload-candidate-document.module';
import { MoveDocumentFolderModule } from '../move-document-folder/move-document-folder.module';
import { DeleteCandidateDocumentModule } from '../delete-candidate-document/delete-candidate-document.module';
import { EmailDocumentsModule } from '../email-documents/email-documents.module';
import { AvailableDocumentsModule } from '../available-documents/available-documents.module';
import { CandidateProfileActionsModalComponent } from './candidate-profile-actions-modal.component';

@NgModule({
  declarations: [CandidateProfileActionsModalComponent],
  imports: [
    CommonModule,
    ModalModule.forRoot(),
    AddEditCandidateContactModule,
    AddEditEmployeeModule,
    AddEditDocumentFolderModule,
    UploadCandidateDocumentModule,
    MoveDocumentFolderModule,
    DeleteCandidateDocumentModule,
    EmailDocumentsModule,
    AvailableDocumentsModule
  ],
  exports: [CandidateProfileActionsModalComponent],
  entryComponents: [CandidateProfileActionsModalComponent]
})
export class CandidateProfileActionsModalModule { }
